import type { ReactElement } from 'react';

type iconType = {
  width: number;
  height: number;
  color: string;
};

function Announcement(props: iconType): ReactElement {
  const { width, height, color } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`color-${color}`}
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 0H0V20L4 16H20V0ZM11 9H9V3H11V9ZM9 13H11V11H9V13Z"
      />
    </svg>
  );
}

export default Announcement;
